import { AT } from '../../actions/actionTypes';
import { getStateFull, doAction, dispatch } from '../../core/redux/store';
import * as MyKeysApiDTypes from '../../core/apis/mykeys/devicetypes';

import { getColumns } from '../../components/devicetypesPage/columns';
import * as DT from '../datatable';
import * as Devices from '../devices';
import * as DTHelper from '../datatable/utils';

import {
  State,
  SearchPageFetchPL,
  SearchPageSuccessPL,
  SearchPageResponse,
  DeviceType,
  FilterCriteria,
  SearchPageErrorPL,
} from './model';
import { ErrorDataResponse } from '../../core/apis/mykeys/exceptions';
import { SortCriteria } from '../datatable';
import {
  buildCriteraList,
  updateCriteria,
  clearCriterionByType,
} from '../../core/apis/mykeys/searchCriteria';
import { getTotalsFromSelectedKeys, msgSearchError } from './utils';
import { criterionNames, SearchCriteriaDto } from '../../interfaces';
import { FeedbackAddPL } from '../../models';
import Logger from '../../libs/logger';   import { LogArea } from '../../libs/logger/const';

export const getState = (): State => getStateFull().deviceTypesState;

export const changeTablePage = (pageNumber: number) =>
  dispatch(DT.changeTablePage(AT.DTYPES.TABLE_PAGE_CHANGE, pageNumber));

export const changeTableSizePage = (pageSize: number) =>
  dispatch(DT.changeTableSizePage(AT.DTYPES.TABLE_PAGESIZE_CHANGE, pageSize));

export const changeTableSorting = (sort: SortCriteria[]) =>
  dispatch(DT.changeTableSorting(AT.DTYPES.SORT_CRITERIA_UPADATED, sort));

export const updateTableItemSelection = (item: DeviceType) =>
  dispatch(DT.updateTableItemSelection(AT.DTYPES.TABLE_TOGGLE_ITEM, item));

export const clearSelection = () =>
  dispatch({ type: AT.DTYPES.CLEAR_SELECTION });

export const updateTableSelectAll = () => {
  dispatch({ type: AT.DTYPES.TABLE_TOGGLE_ALL });
};

export const isTableItemSelected: DT.IsItemSelectedType<DeviceType> = (o) =>
  DTHelper.isTableItemSelected(o, getState().selection);

export const updateFilterCriteria = (
  criteria: FilterCriteria,
  isLoading: boolean
) => {
  if (isLoading) return;
  dispatch({
    type: AT.DTYPES.FILTER_CRITERIA_UPADATED,
    payload: criteria,
  });
};

export const updateDTColumns = (columns: DT.TableColumn[]) => {
  dispatch({ type: AT.DTYPES.TABLE_COLUMNS, payload: columns });
};
export const updateColumns = () => updateDTColumns(getColumns());

/* Server Actions */

export const searchPage = (pageNumber: number) => {
  const state = getState();
  const page = DTHelper.getDataPage(state.data.pages, pageNumber);

  if (page && page.isFetching) return;

  const basePayload: DT.SearchPageBasePayload = {
    pageNumber,
    version: state.data.version,
  };

  MyKeysApiDTypes.searchPage(pageNumber, state)
    .then((res: SearchPageResponse) => {
      const payload = { ...res, ...basePayload };
      doAction<SearchPageSuccessPL>(AT.DTYPES.SEARCH_SUCCESS, payload);
    })
    .catch((err: ErrorDataResponse) => {
      Logger.warn([err], LogArea.Redux);
      doAction<SearchPageErrorPL>(AT.DTYPES.SEARCH_ERROR, basePayload);
      doAction<FeedbackAddPL>(AT.FEEDBACK_ADD_ERROR, {
        content: [msgSearchError],
      });
    });

  doAction<SearchPageFetchPL>(AT.DTYPES.SEARCH_FETCH, basePayload);
};

export const getCriteria = (keys: string[]) => {
  const state = getState();
  const criteria = buildCriteraList(state.filters, state.sort);
  // remove manual filters on search
  criteria.criteriaDtos = clearCriterionByType(
    criteria.criteriaDtos,
    SearchCriteriaDto.deviceName
  );
  // add selected items
  keys.map((k) =>
    updateCriteria(criteria.criteriaDtos, criterionNames.deviceName, k)
  );
  return criteria;
};

export const getTotals = (keys: string[] = []) => {
  const state = getState();
  const { data } = state;

  return getTotalsFromSelectedKeys(keys, data) as Devices.TotalsByType;
};
